<template>
  <div class="footer-container">
		<div id="fd">
            <div class="fd-info">
                <div class="wp">
                    <div class="fd-l">
                        <dl>
                            <dt><img src="../../assets/images/logo-fd.png" alt=""></dt>
                            <dd>
                                <p>苏州文化艺术中心教育培训中心版权所有©2020</p>
                                <p @click="clickIcp()" style="cursor:pointer;">苏ICP备10211593号-7</p>
                                <p>地址：中国江苏省苏州工业园区观枫街1号</p>
                            </dd>
                        </dl>
                    </div>
                    <div class="fd-r">
                        <div class="qr-box">
                            <img src="../../assets/images/qr.gif" alt="">
                            <p>关注我们</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fd-cp">
                <div class="wp">
                    <div class="left">
                        <p><span>Copyright &copy;Suzhou Culture and Arts School, All Rights Reserved</span><a href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备10211593号-7</a></p>
                    </div>
                    <div class="right">
                        <a  @click="clickKgu()" class="kgu">技术支持： <img src="../../assets/images/kgu.png" alt=""> </a>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
	props: {
		homeData22: {}
	},
  data() {
    return {
	}
  },
  created() {
	//this.config.url = window.location.href;
	
  },
  methods:{
    clickIcp() {
      // console.log(123)
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    clickKgu() {
      window.open("https://www.7m5.cn");
    }
  }
}
</script>

<style>
    @import url("../../assets/css/style.css");
    /* @import url("../../assets/css/less.css"); */
</style>

<style>
  .social-share .icon-wechat,.social-share .icon-douban,.social-share .icon-weibo,.social-share .icon-qq {
      color: #fff !important;
      border-color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navFooter.vue